import { render, staticRenderFns } from "./ChangelogDashboard.vue?vue&type=template&id=4c733e01&scoped=true"
import script from "./ChangelogDashboard.vue?vue&type=script&lang=js"
export * from "./ChangelogDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c733e01",
  null
  
)

export default component.exports